export default [
    {
        header: 'Marketing',
        icon: 'fa-solid fa-arrow-trend-up',
        children: [{
                title: 'Estadisticas',
                route: 'marketing',
                icon: 'fa-solid fa-chart-pie'
            },
            {
                title: 'Awin',
                route: 'shareasale',
                icon: 'fa-solid fa-star'
            },
            {
                title: 'Reporte Ventas',
                route: 'map',
                icon: 'fa-solid fa-chart-line'
            },
            {
                title: 'Reporte Ventas v2',
                route: 'map-v2',
                icon: 'fa-solid fa-map-location-dot'
            },
            {
                title: 'Automatizaciones',
                route: 'automatizaciones-plataforma',
                icon: 'fa-solid fa-server'
            },
            {
                title: 'Gestion Influencers',
                route: 'gestion-influencers',
                icon: 'fa-solid fa-people-roof'
            },
            {
                title: 'Gestion Plantillas',
                route: 'gestion-plantillas',
                icon: 'fa-solid fa-envelopes-bulk'
            },
            {
                route: 'pedido-taller-vero-fabricando',
                icon: 'fa-solid fa-cubes',
                title: 'En Produccion'
            }
        ]
    },
    {
        header: 'B2C',
        icon: 'fa-solid fa-user-tag',
        children: [{
                title: 'Prevision',
                route: 'prevision',
                icon: 'fa-solid fa-box-archive'
            },
            {
                route: 'pedido-taller-vero',
                icon: 'fa-solid fa-industry',
                title: 'Pedidos Taller Vero'
            },
            {
                route: 'pedido-taller-vero-progreso-mano',
                icon: 'fa-solid fa-warehouse',
                title: 'Progreso Almacen'
            }
        ]
    },
    {
        header: 'B2B',
        icon: 'fa-solid fa-handshake',
        children: [
            {
                route: 'pedido-taller-vero-b2b',
                icon: 'fa-solid fa-handshake',
                title: 'Pedidos Taller Vero B2B'
            },
            {
                route: 'customers',
                icon: 'fa-solid fa-address-book',
                title: 'Customers'
            },
            {
                route: 'potencial-customers',
                icon: 'fa-solid fa-user-plus',
                title: 'Potencial Customers'
            },
            {
                title: 'Labels',
                route: 'etiquetas',
                icon: 'fa-solid fa-tags'
            },
            {
                title: 'Create Order',
                route: 'escaner',
                icon: 'fa-solid fa-barcode'
            },
            {
                title: 'Orders',
                route: 'escaner-pedidos',
                icon: 'fa-solid fa-clipboard-list'
            },
            {
                title: 'Web B2B',
                route: 'wholesale-catalogo',
                icon: 'fa-solid fa-globe'
            },
            {
                route: 'proformas',
                icon: 'fa-solid fa-money-check-dollar',
                title: 'Control Pagos'
            },
            {
                route: 'facturas',
                icon: 'fa-solid fa-file-invoice-dollar',
                title: 'Facturas'
            },
            {
                route: 'creditos',
                icon: 'fa-solid fa-hand-holding-dollar',
                title: 'Créditos'
            },
            {
                route: 'statements',
                icon: 'fa-solid fa-file-lines',
                title: 'Statements'
            },
        ]
    },
    {
        header: 'Producción',
        icon: 'fa-solid fa-shop',
        children: [
            {
                route: 'proveedores',
                icon: 'fa-solid fa-users',
                title: 'Proveedores'
            },
            {
                route: 'materiales',
                icon: 'fa-solid fa-box',
                title: 'Materiales'
            },
            {
                route: 'skumateriales',
                icon: 'fa-solid fa-server',
                title: 'Sku-Materiales'
            },
            {
                route: 'stock',
                icon: 'fa-solid fa-boxes-stacked',
                title: 'Stock'
            },
            {
                route: 'almacen',
                icon: 'fa-solid fa-warehouse',
                title: 'Almacén RFID'
            },
            {
                route: 'calculadora',
                icon: 'fa-solid fa-calculator',
                title: 'Calculadora'
            },
            {
                route: 'tiempos',
                icon: 'fa-solid fa-stopwatch-20',
                title: 'Tiempos'
            },
            {
                route: 'pedido-materiales',
                icon: 'fa-solid fa-cart-shopping',
                title: 'Pedidos'
            },
            {
                title: 'EAN List',
                route: 'ean-list',
                icon: 'fa-solid fa-barcode'
            },
            {
                title: 'EAN Duplicados',
                route: 'ean-duplicados',
                icon: 'fa-solid fa-clone'
            }, {
                title: 'SKU List',
                route: 'sku-list',
                icon: 'fa-solid fa-terminal'
            },
            {
                title: 'SKU Amazon',
                route: 'sku-amazon',
                icon: 'fa-brands fa-amazon'
            },
            {
                title: 'Amazon ↔ Shopify',
                route: 'amazon-shopify',
                icon: 'fa-solid fa-link'
            },
            {
                title: 'Amazon Productos',
                route: 'amazon-productos',
                icon: 'fa-brands fa-amazon'
            },

        ]
    },
    {
        header: 'Finanzas',
        icon: 'fa-solid fa-file-invoice-dollar',
        children: [  {
            title: 'Albaran',
            route: 'albaran',
            icon: 'fa-solid fa-receipt'
        },{
            title: 'Albaran Auto',
            route: 'albaranV2',
            icon: 'fa-solid fa-play'
        },
       {
            title: 'Facturas',
            route: 'factura',
            icon: 'fa-solid fa-file-invoice-dollar'
        }, {
            title: 'Factura Shopify PDF',
            route: 'shopify-invoice-pdf',
            icon: 'fa-brands fa-shopify'
        }, {
            title: 'Gastos Proveedores',
            route: 'gastos-proveedor',
            icon: 'fa-solid fa-users'
        }, {
            title: 'Precios Sku',
            route: 'precios-sku',
            icon: 'fa-solid fa-coins'
        }, {
            title: 'IVA Ventas Europa',
            route: 'report',
            icon: 'fa-solid fa-percent'
        }, {
            title: 'Fedex',
            route: 'fedex',
            icon: 'fa-brands fa-fedex'
        },
        {
            title: 'UPS',
            route: 'ups',
            icon: 'fa-brands fa-ups'
        },
        {
            title: 'UPS Facturas',
            route: 'ups-facturas',
            icon: 'fa-solid fa-file-invoice'
        }, {
            title: 'Corporation Tax',
            route: 'corporation-tax',
            icon: 'fa-solid fa-hand-holding-dollar'
        }, {
            title: 'KPI',
            route: 'kpi',
            icon: 'fa-regular fa-calendar-days'
        },{
            header: 'Gastos',
            route: 'kpi-gastos',
            icon: 'fa-solid fa-basket-shopping',
            title: 'Gastos'
        },/*,{
            header: 'Bancos',
            route: 'bancos',
            icon: 'fa-solid fa-piggy-bank',
            title: 'Bancos'
        }*/]
    },
    {
        header: 'Taller',
        icon: 'fa-solid fa-industry',
        children: [
            {
                title: 'Gestionar día',
                route: 'gestionar',
                icon: 'fa-solid fa-people-roof'
            },
            {
                title: 'Pedidos Taller',
                route: 'pedidos',
                icon: 'fa-solid fa-boxes-packing'
            },
            {
                title: 'Patrones',
                route: 'patrones',
                icon: 'fa-solid fa-scroll'
            },
            // {
            //     route: 'pedido-taller-vero-progreso',
            //     icon: 'fa-solid fa-tasks',
            //     title: 'Progreso Taller'
            // },
            {
                route: 'pedido-taller-vero-progreso-corte',
                icon: 'fa-solid fa-scissors',
                title: 'Progreso Corte'
            },
            {
                title: 'Reportes',
                route: 'reportes',
                icon: 'fa-solid fa-circle-exclamation'
            },
            {
                title: 'Sku Titulo',
                route: 'sku-titulo',
                icon: 'fa-solid fa-heading'
            },
            {
                title: 'Semanas Produccion',
                route: 'sku-semanas-produccion',
                icon: 'fa-solid fa-hourglass-half'
            },
            {
                title: 'Guias',
                icon: 'fa-solid fa-book',
                children: [{
                        title: 'Guia Corte',
                        route: 'guia-corte',
                        icon: 'fa-solid fa-book'
                    },
                    {
                        title: 'Guia Mano',
                        route: 'guia-mano',
                        icon: 'fa-solid fa-book-atlas'
                    },
                    {
                        title: 'Guia Preparado',
                        route: 'guia-preparado',
                        icon: 'fa-solid fa-book-journal-whills'
                    },
                    {
                        title: 'Guia Mano Medidas',
                        route: 'guia-mano-medidas',
                        icon: 'fa-solid fa-minimize'
                    },
                ]
            },
            {
                title: 'Corte',
                route: 'corte',
                icon: 'fa-solid fa-scissors'
            },
            {
                title: 'Preparado',
                route: 'preparado',
                icon: 'fa-solid fa-people-carry-box'
            },
            {
                title: 'Confeccion',
                route: 'confeccion',
                icon: 'fa-solid fa-hands-holding-circle'
            },
            {
                title: 'Guia Corte',
                route: 'guia-corte',
                icon: 'fa-solid fa-book'
            },
            {
                title: 'Guia Mano',
                route: 'guia-mano',
                icon: 'fa-solid fa-book-atlas'
            },
            {
                title: 'Guia Preparado',
                route: 'guia-preparado',
                icon: 'fa-solid fa-book-journal-whills'
            },
            {
                title: 'Guia Mano Medidas',
                route: 'guia-mano-medidas',
                icon: 'fa-solid fa-minimize'
            },
            {
                title: 'Trabajo',
                icon: 'fa-solid fa-briefcase',
                children: [{
                        title: 'Corte',
                        route: 'corte',
                        icon: 'fa-solid fa-scissors'
                    },
                    {
                        title: 'Preparado',
                        route: 'preparado',
                        icon: 'fa-solid fa-people-carry-box'
                    },
                    {
                        title: 'Confeccion',
                        route: 'confeccion',
                        icon: 'fa-solid fa-hands-holding-circle'
                    },
                ]
            },
            {
                title: 'Master',
                icon: 'fa-solid fa-eye',
                children: [{
                        title: 'Corte',
                        route: 'master-corte',
                        icon: 'fa-solid fa-scissors'
                    },
                    {
                        title: 'Confeccion',
                        route: 'master-confeccion',
                        icon: 'fa-solid fa-hands-holding-circle'
                    },
                    {
                        title: 'Fabricacion',
                        route: 'master-fabricacion',
                        icon: 'fa-solid fa-list-check'
                    },
                ]
            },
            {
                title: 'Máquinas',
                route: 'maquinas',
                icon: 'fa-solid fa-gears'
            },
            {
                title: 'Label Designer',
                route: 'etiquetas-disenador',
                icon: 'fa-solid fa-pen-ruler'
            },
        ],
      },
    {
        header: 'Website',
        icon: 'fa-brands fa-chrome',
        children: [{
            header: 'Medidas',
            route: 'medidas',
            icon: 'fa-solid fa-ruler',
            title: 'Medidas'
        },
        {
            header: 'Upload',
            route: 'upload',
            icon: 'fa-solid fa-upload',
            title: 'Upload'
        },
        {
            header: 'Language',
            route: 'language',
            icon: 'fa-solid fa-language',
            title: 'Language'
        },
        {
            header: 'Return Reasons',
            route: 'return-reasons',
            icon: 'fa-solid fa-rotate-left',
            title: 'Return Reasons'
        },
        ]
    },
    {
        header: 'Usuarios',
        route: 'gestion-usuarios',
        icon: 'fa-solid fa-users',
        title: 'Usuarios'
    },
    {
        header: 'Personal',
        icon: 'fa-solid fa-user-clock',
        children: [
            {
                title: 'Mi Fichaje',
                route: 'fichaje',
                icon: 'fa-solid fa-clock'
            },
            {
                title: 'Admin Fichajes',
                route: 'fichaje-admin',
                icon: 'fa-solid fa-users-gear'
            },
            {
                title: 'Calendario',
                route: 'vacaciones-mi-calendario',
                icon: 'fa-regular fa-calendar'
            },
            {
                title: 'Admin Vacaciones',
                route: 'vacaciones-admin',
                icon: 'fa-solid fa-calendar-days'
            },
            {
                title: 'Avisos',
                route: 'avisos',
                icon: 'fa-solid fa-bell'
            }
        ]
    },
    {
        header: 'Gmail',
        icon: 'fa-brands fa-google',
        children: [
{
                header: 'Correos',
                route: 'ia-gmail-v2',
                icon: 'fa-solid fa-inbox',
                title: 'Correos'
            },{
                header: 'Plantillas',
                route: 'ia-gmail-plantillas',
                icon: 'fa-solid fa-envelopes-bulk',
                title: 'Plantillas'
            }]
    }
]
